
import React from 'react';
import {css} from 'emotion';
import {FormEditBlock} from '../../../frontend/helpers/FormEdit/FormEditBlock.jsx';
import {FormEditFormFieldCode} from '../../../frontend/helpers/FormEdit/FormEditFormFieldCode.jsx';
import {FormEditFormFieldRecordsViewCode} from '../../../frontend/helpers/FormEdit/FormEditFormFieldRecordsViewCode.jsx';
import {FormEditNavigation} from '../../../frontend/helpers/FormEdit/FormEditNavigation.jsx';
import {useStateAtom} from '../../../utilities/React/UseStateAtom.js';
import {wrapStateAtom} from '../../../libs/reactjs/wrapStateAtom.js';

export const FormEdit = function (props) {

  const pageActiveIndex = useStateAtom(0);
  const blockActiveIndex = useStateAtom(-1);
  const subBlockActiveIndex = useStateAtom(-1);

  return (<>
    <div
      className={css`
        display: flex;
        flex-direction: row;
        align-content: stretch;
        align-items: stretch;
        gap: 16px;
        width: 100%;
        height: 100%;
      `}
    >
      <div
        className={css`
          flex: none;
          width: 384px;
          border-style: solid;
          border-width: 1px;
          border-color: #d1d5db;
          height: 100%;
          overflow: auto;
        `}
      >
        <FormEditNavigation
          definitionAST={props.definitionAST}
          pageActiveIndex={pageActiveIndex}
          blockActiveIndex={blockActiveIndex}
          subBlockActiveIndex={subBlockActiveIndex}
          underTheHood={props.underTheHood}
        />
      </div>
      <div
        className={css`
          width: 100%;
          height: 100%;
          overflow: auto;
        `}
      >
        {(() => {
          if (pageActiveIndex() == -1) {
            return (<>
              <div
                className={css`
                  display: flex;
                  flex-direction: column;
                  gap: 8px;
                `}
              >
                <div>
                  {props.underTheHood && (<>
                    <FormEditFormFieldRecordsViewCode
                      definitionAST={props.definitionAST}
                    />
                  </>)}
                </div>
                <div>
                  {props.underTheHood && (<>
                    <FormEditFormFieldCode
                      definitionAST={props.definitionAST}
                    />
                  </>)}
                </div>
              </div>
            </>);
          }
          //if (props.definitionAST().pages[pageActiveIndex()].blocks[blockActiveIndex()].component == 'Group')
          if (subBlockActiveIndex() != -1) {
            if (!props.definitionAST().pages[pageActiveIndex()]?.blocks?.[blockActiveIndex()]?.blocks?.[subBlockActiveIndex()])
              return (<></>);
            return (<>
              <FormEditBlock
                noGroup={true}
                block={wrapStateAtom(
                  props.definitionAST().pages[pageActiveIndex()].blocks[blockActiveIndex()].blocks[subBlockActiveIndex()],
                  (state) => {
                    props.definitionAST({
                      ...props.definitionAST(),
                      pages: [
                        ...props.definitionAST().pages.slice(0, pageActiveIndex()),
                        {
                          ...props.definitionAST().pages[pageActiveIndex()],
                          blocks: [
                            ...props.definitionAST().pages[pageActiveIndex()].blocks.slice(0, blockActiveIndex()),
                            {
                              ...props.definitionAST().pages[pageActiveIndex()].blocks[blockActiveIndex()],
                              blocks: [
                                ...props.definitionAST().pages[pageActiveIndex()].blocks[blockActiveIndex()].blocks.slice(0, subBlockActiveIndex()),
                                state,
                                ...props.definitionAST().pages[pageActiveIndex()].blocks[blockActiveIndex()].blocks.slice(subBlockActiveIndex() + 1),
                              ],
                            },
                            ...props.definitionAST().pages[pageActiveIndex()].blocks.slice(blockActiveIndex() + 1),
                          ],
                        },
                        ...props.definitionAST().pages.slice(pageActiveIndex() + 1),
                      ],
                    });
                  },
                )}
                underTheHood={props.underTheHood}
              />
            </>);
          }
          if (blockActiveIndex() != -1) {
            if (!props.definitionAST().pages[pageActiveIndex()]?.blocks?.[blockActiveIndex()])
              return (<></>);
            return (<>
              <FormEditBlock
                block={wrapStateAtom(
                  props.definitionAST().pages[pageActiveIndex()].blocks[blockActiveIndex()],
                  (state) => {
                    props.definitionAST({
                      ...props.definitionAST(),
                      pages: [
                        ...props.definitionAST().pages.slice(0, pageActiveIndex()),
                        {
                          ...props.definitionAST().pages[pageActiveIndex()],
                          blocks: [
                            ...props.definitionAST().pages[pageActiveIndex()].blocks.slice(0, blockActiveIndex()),
                            state,
                            ...props.definitionAST().pages[pageActiveIndex()].blocks.slice(blockActiveIndex() + 1),
                          ],
                        },
                        ...props.definitionAST().pages.slice(pageActiveIndex() + 1),
                      ],
                    });
                  },
                )}
                underTheHood={props.underTheHood}
              />
            </>);
          }
          if (!props.definitionAST().pages[pageActiveIndex()])
            return (<></>);
          return (<>
            <FormEditBlock
              block={wrapStateAtom(
                props.definitionAST().pages[pageActiveIndex()],
                (state) => {
                  props.definitionAST({
                    ...props.definitionAST(),
                    pages: [
                      ...props.definitionAST().pages.slice(0, pageActiveIndex()),
                      state,
                      ...props.definitionAST().pages.slice(pageActiveIndex() + 1),
                    ],
                  });
                },
              )}
              underTheHood={props.underTheHood}
            />
          </>);
        })()}
      </div>
    </div>
  </>);

};
